var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('MenuComponent'),_c('HeroComponent'),_vm._l((_vm.sections),function(section){return _c('SectionComponent',{key:section.Id,attrs:{"current":section}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }